/**
 * toastBus — sonner `toast()` fired from non-React modules (axios
 * interceptors, sync queue timers) is lost if it happens before <Toaster>
 * mounts (e.g. while AuthProvider is still resolving). Bridge + buffer:
 * events are queued until App signals it's ready, then replayed.
 */
export function busToast(kind, title, opts) {
  const detail = { kind, title, opts };
  try {
    if (window.__selloxToastReady) {
      window.dispatchEvent(new CustomEvent("sellox-toast", { detail }));
    } else {
      (window.__selloxToastBuf = window.__selloxToastBuf || []).push(detail);
    }
  } catch {}
}

/** Called once from App: marks ready, replays buffered toasts via handler. */
export function drainToastBuffer(handler) {
  window.__selloxToastReady = true;
  const buf = window.__selloxToastBuf || [];
  window.__selloxToastBuf = [];
  buf.forEach(handler);
}
